import Service from "@/services";
import DeeplinkEvent from "@/components/DeeplinkHandler/DeeplinkEvent";
import { buildTemplate2MessageBodyBatch } from "@/utils/chat/message";

const MAX_SEND_COUNT = 10;

// 校验参数合法性
const validateData = (data: any) => {
  const { cardInfo, toUidList, gidList, appKey } = data;
  return (
    typeof cardInfo !== "object" ||
    (toUidList && !Array.isArray(toUidList)) ||
    (gidList && !Array.isArray(gidList)) ||
    !appKey
  );
};

// 超限校验
const isOverLimit = (data: any) => {
  const { toUidList, gidList } = data;
  const uidLen = toUidList?.length || 0;
  const gidLen = gidList?.length || 0;

  return uidLen + gidLen > MAX_SEND_COUNT;
};

// 用户ID转换
const changeMessageUser = (data: any, service: Service): Promise<any> => {
  const { isInnerApp, appKey, toUidList } = data;
  let changeUserPromise: Promise<any> = Promise.resolve();
  if (isInnerApp === 2 && toUidList?.length) {
    changeUserPromise = service.appStoreService
      .batchExchangeUser({
        appKey,
        openUserTeamIds: toUidList
      })
      .then((data: any) => {
        const resData = data?.userTeamIds?.map((item: any, index: number) => {
          return {
            pin: item.userId,
            app: toUidList[index].app,
            teamId: item.teamId
          };
        });
        return resData;
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  } else {
    let resData = toUidList;
    if (toUidList?.length) {
      resData = toUidList.map((item: any) => {
        return {
          pin: item.userId,
          app: item.app,
          teamId: item.teamId
        };
      });
    }
    changeUserPromise = Promise.resolve(resData);
  }
  return changeUserPromise;
};

// 卡片deeplink地址创建
const buildCardDeepLink = (
  { govUrl, egovUrl }: { govUrl: string; egovUrl: string } = { govUrl: "", egovUrl: "" }
) => {
  if (DeeplinkEvent.isDeeplink(govUrl)?.[0]) {
    return govUrl;
  }
  const mparam = encodeURIComponent(
    JSON.stringify({
      url: govUrl,
      egovUrl: egovUrl
    })
  );
  return `${((window as any)?._BTS_CONFIG?.REACT_APP_DD_APPID || process.env.REACT_APP_DD_APPID || "").replace(/_/g, "")}://jm/sys/browser/?mparam=${mparam}`;
};

// 拼接消息卡片信息
const buildCardInfoByAppKey = (data: any, service: Service) => {
  const { cardInfo } = data;
  const { pcUrl, pcEgovUrl, mobileUrl, mobileEgovUrl, optionList } = cardInfo || {};
  return service.appStoreService
    .getApplication({
      applicationKey: data.appKey
    })
    .then((res: any) => {
      if (res?.application) {
        const { applicationKey, name, icon } = res.application || {};
        return {
          ...cardInfo,
          pcUrl: buildCardDeepLink({ govUrl: pcUrl, egovUrl: pcEgovUrl }),
          mobileUrl: buildCardDeepLink({ govUrl: mobileUrl, egovUrl: mobileEgovUrl }),
          optionList: optionList?.map((item: any) => {
            return {
              ...item,
              pcUrl: buildCardDeepLink({ govUrl: item.pcUrl, egovUrl: item.pcEgovUrl }),
              mobileUrl: buildCardDeepLink({
                govUrl: item.mobileUrl,
                egovUrl: item.mobileEgovUrl
              })
            };
          }),
          applicationName: name,
          applicationKey,
          icon
        };
      }
      return Promise.reject(new Error("未获取到应用信息，请检查您的appKey是否正确"));
    });
};

// 批量发送消息卡片
const batchSendMessage = ({
  data,
  cid,
  service,
  sendToMessage
}: {
  data: any;
  cid: any;
  service: Service;
  sendToMessage: (arg: any) => void;
}) => {
  const { cardInfo, gidList, appKey } = data;
  if (validateData(data)) {
    sendToMessage({
      cid,
      data: {
        errorCode: 10000400,
        errorMessage: "参数不合法"
      }
    });
    return;
  }

  if (isOverLimit(data)) {
    sendToMessage({
      cid,
      data: {
        errorCode: 10000401,
        errorMessage: "发送数量超过最大限制"
      }
    });
    return;
  }
  buildCardInfoByAppKey({ appKey, cardInfo }, service)
    .then((card: any) => {
      changeMessageUser(data, service)
        .then(
          (data: any) => {
            console.log("to人员信息--", data);
            return buildTemplate2MessageBodyBatch({
              cardInfo: card,
              toUidList: data,
              gidList
            });
          },
          (error: any) => {
            sendToMessage({
              cid,
              data: {
                errorCode: 10000403,
                errorMessage: error?.message || "转换人员信息出错"
              }
            });
            return;
          }
        )
        .then((res: any) => {
          console.log("发送消息结果--", res);
          const [rtnData, errorMessage] = res;
          let rtnObj = rtnData;
          if (!rtnData) {
            rtnObj = {
              errorCode: 10000405,
              errorMessage: errorMessage || "发送消息出错"
            };
          }
          sendToMessage({
            cid,
            data: rtnObj
          });
          return;
        })
        .catch((e: any) => {
          console.log("发送消息异常--", e);
          sendToMessage({
            cid,
            data: {
              errorCode: 10000404,
              errorMessage: e?.message || "批量发送消息出错"
            }
          });
          return;
        });
    })
    .catch((e: any) => {
      sendToMessage({
        cid,
        data: {
          errorCode: 10000406,
          errorMessage: e?.message || "构建卡片信息出错"
        }
      });
      return;
    });
};

export { batchSendMessage };
